
<template>
  <div >
    <md-dialog :md-active.sync="showDialog" :md-click-outside-to-close="false">
      <md-dialog-title class = "heading">Walk In Appt</md-dialog-title>
     

      <md-dialog-content >
        <form id = "top" novalidate @submit.prevent="doSaveUser">

    <div class = "down">
     <div class = "inputBoxDoubleLoadList">
        <div class = "inputBoxWide">
          <div>
            <auto-complete-master-data-select :class="getValidationClass('dataForm.receivingWindows')"
                                                group="REC_WINDOW"
                                                label="Receiving Windows"
                                                :init-value="dataForm.receivingWindows"
                                                :on-item-changed="handleWindowsChanged"
                                                >
            </auto-complete-master-data-select>

          
          </div>
        </div>
     </div>

     <div class = "inputBoxDoubleLoadList">
        <div class = "inputBoxWide">
          <auto-complete-master-data-select :class="getValidationClass('dataForm.dockType')"
                                            group="DOCKTYPE"
                                            label="Dock Type"
                                            :init-value="dataForm.dockType"
                                            :on-item-changed="handleDockChanged"
                                            >
          </auto-complete-master-data-select>
        </div>
     </div>

     <div class = "inputBoxDoubleLoadList">
        <div class = "inputBoxWide">
          <div>
             <div :class="getValidationClass('dataForm.apptDate')">
                <datepicker v-model="dataForm.apptDate">
                    <label>Appoinment Date</label>
                    <span class="md-error" v-if="!$v.dataForm.apptDate.required">Appoinment date is required<br/></span>
                </datepicker>
            </div>
          </div>
        </div>
     </div>

     <div class = "inputBoxDoubleLoadList">
        <div class = "inputBoxWide">
          <div :class="getValidationClass('dataForm.apptTime')">
            <md-field>
              <label>Appoinment Time</label>
              <md-input v-model="dataForm.apptTime" placeholder="Format: HH:MM:SS"></md-input>
              <span class="md-error" v-if="!$v.dataForm.apptTime.required">Appoinment time is required<br/></span>
              <span class="md-error" v-else-if="!$v.dataForm.apptTime.add">Appoinment time format is invalid!<br/></span>
              <!-- <span class="md-error" v-if="this.timeError != null">{{this.timeError}}<br/></span> -->
            </md-field>
            <span class="errorMsg" v-if="apptTimeInvalid">{{ apptTimeFormatErr }}</span>
        </div>
        </div>
     </div>

     <div class = "inputBoxDoubleLoadList">
        <div class = "inputBoxWide">
             <md-field  :class="getValidationClass('dataForm.inboundShipment')">
                  <label>Inbound Shipment</label>
                  
             </md-field>
             
            <template class="loadingInput">
                <calling-api path="/api/w/fsi/WebSearchWalkIn"> 
                <b-field>
                    <b-input @keyup.native="checkIBS" class="loadingInput" 
                        size="is-small"
                        :loading="loading"
                        placeholder="Inbound Shipment"
                        v-model="dataForm.inboundShipment"></b-input>
                </b-field>
                </calling-api>
                <div class="errorMessage" v-if="ibsError">{{ibsError}}</div>
            </template>
        </div>
     </div>



     <div class = "inputBoxDoubleLoadList">
        <div class = "inputBoxWide">
          <md-field  :class="getValidationClass('dataForm.remark')">
            <label for="remark">Remark</label>
            <md-input name="remark"
                      id="remark"
                      autocomplete="new-password"
                      v-model="dataForm.remark"
            />
          </md-field>
        </div>
     </div>


    </div>

        <div class = "alwaysShow">
          <callingApiCenter type="bar" :paths="['/api/w/gst/loadlist/create','/api/w/users','/api/w/gst/loadlist', '/api/w/gst/createyardstage']"></callingApiCenter>
          <div>
            <md-dialog-actions >
              <md-button class="md-raised custButtonForm " @click="cancalAction"><span class="icons-center material-icons">cancel</span>Close</md-button>
              <!-- <md-button type="submit" class="md-raised custButtonForm "><span class="icons-center material-icons">create</span>Create</md-button> -->

              <md-button 
                class="custButtonForm md-raised"
                @click="doSaveUser" 
                :disabled="getDisable">
                Create
              </md-button>

            </md-dialog-actions>
          </div>
        </div>
      </form>
      </md-dialog-content>
    </md-dialog>
  </div>
</template>


<style scoped>


.container {
  display: flex;
  flex-direction: row;
  margin: auto;
  width: 300px;
}



  form {
    min-width: 560px;
    margin: 24px;
  }
  
  .alwaysShow {
    position: fixed;
    right: 60px;
    top : 30px;
  }

  
  .redButton{
    background-color: #c50000;
    z-index: 4;
    box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);
  }


  .icons-center {
    vertical-align: middle;
    margin-right: 10px;
  }

  .custButtonForm {
    margin: 10px;
    width: 100px;
    height: 40px;
    line-height:40px;
    font-size: 0.7rem; 
  }

  .heading{
    padding-top: 20px;
    margin-bottom: 0;
    color: #555555;
    width: 92%;
    line-height: 3;
    font-size: 32px;
    font-family: Roboto Slab;
    margin-left: 60px;
  }

  .layout{
    margin-top: 0px;
    margin-bottom: 0px;
    padding-top: 0px;
    padding-bottom: 0px;
    width: 92%;
    line-height: 1;
    color: #555555;
    font-family: Roboto Slab;
    margin: auto;
  }


  .inputBoxDoubleLoadList {
  width: 500px;
  justify-content: space-around;
  display: flex;
  flex-direction: row;
  margin: auto;
}

.inputSpace {
  color: #29303b;
  font-size: 18px;
  height: auto;
  width: 200px;
  line-height: 1em;
}

.inputBoxWide {
  color: #29303b;
  font-size: 18px;
  height: auto;
  width: 450px;
  line-height: 1em;
}

.inputCheckBoxWide {
  color: #29303b;
  font-size: 18px;
  height: auto;
  width: 450px;
  line-height: 1em;
}


    .loadingInput {
      margin: 0 !important;
      padding: 2px !important;
      vertical-align:top;
    }
    .errorMessage {
      color: #f14668;
      text-align: left;
      padding-left: 5px;
    }
    .warningMessage {
      color: #32997f;
      text-align: left;
      padding-left: 5px;
    }

.errorMsg{
   color:#c50000;
   font-size: 12px;

}

</style>

<script>
  import { validationMixin } from 'vuelidate';
  import { mapGetters } from 'vuex';
  import dateFormat from '../utils/dateFormat';
  import { minLength, required , maxLength} from 'vuelidate/lib/validators';
  import AutocompleteCcicLocationSelect from "./AutocompleteCcicLocationSelect.vue";
  import AutocompleteSelect from "./AutoCompleteDebounceSelect.vue";
  import callingApiCenter from "../components/CallingApiCenter.vue";
  //import api from '../api';
  import { newAPIPost } from '../api/index.js';
  import moment from 'moment';

  const getInitialdataForm = () => ({
    receivingWindows: null,
    apptDate: moment().toDate(),
    apptDateLocal: null,
    apptTime: "00:00",
    inboundShipment: "123",
    workIn: 'X',
    remark: null,
    dockType: null,
    createdOn:null,
    username: null,
  });


  export default {
    components: { AutocompleteCcicLocationSelect ,callingApiCenter,AutocompleteSelect},
    mixins: [validationMixin],
    props: {
      mode: String,
      action: Function,
    },
    data: () => ({
      showDialog: false,
      dataForm: getInitialdataForm(),
      loadList: [],
      timeError: null,
      loading: false,
      ibsError: null,
      perIbs: null,
      apptTimeInvalid: false,
      apptTimeFormatErr: null,
    }),
    computed: {
      ...mapGetters([
      "getOutboundsList",
      "getMasterDataName",
      "getMasterDataByGroup",
      "getMasterDataAsSelectOptionByGroup",
      "getPermission",
      "getUserProfile",
      "getRole",
      ]),
      

      getDisable() {
        if (this.dataForm.dockType == null) return true
        if (this.dataForm.inboundShipment == "123" && this.ibsError == null ) return true
        if (this.ibsError != null ) return true
        if (this.dataForm.inboundShipment == null && this.ibsError == null) return false
      },

    },

    validations: {
      dataForm: {
        receivingWindows: {required},
        dockType: {required},
        apptDate:{
                required,
        },
        apptTime:{
            required,
            add : (value) => {
              
              const res = moment('2021-04-01T' + value).toDate();
              return res != 'Invalid Date';
            }
        },
        inboundShipment: {required},
        // workIn: {required},
        // remark: {required},
      
      },
    },


    methods: {

    handleWindowsChanged(id) {
        this.dataForm.receivingWindows = id;
    },

    handleDockChanged(id) {
        this.dataForm.dockType = id;
    },

     async openDialog(existingUser) {
         this.ibsError = null;
         this.apptTimeInvalid = false;
         this.apptTimeFormatErr = null;
        this.$store.commit('clearApiError');
        this.$v.dataForm.$reset();
        console.log(this.$v.dataForm.$invalid);
        this.dataForm = getInitialdataForm();
        this.dataForm.username = this.getUserProfile.username;
        this.dataForm.createdOn = moment()
        this.dataForm.receivingWindows = this.getUserProfile.recWindow;
        this.showDialog = true;
      },


      getValidationClass(fieldName) {
        const field = _(this.$v)
          .lookup(fieldName);

        if (field) {
          return {
            'md-invalid': field.$invalid && field.$dirty,
          };
        }
        return {};
      },


      async  checkIBS(){
        this.ibsError = null;
        this.loading = true;
        console.log("ibs length: " + this.dataForm.inboundShipment.length);
        //console.log("check digit: " + checkdigit);
        if (!this.dataForm.inboundShipment || (this.dataForm.inboundShipment && this.dataForm.inboundShipment.length < 9)) return;
        console.log("perIbs: " + this.perIbs);
        // if (this.perIbs != null)
        // {
        //    if (this.perIbs == this.dataForm.inboundShipment) return
        // }
        //await api.post("/api/w/fsi/WebSearchWalkIn", {
        await newAPIPost("/api/w/fsi/WebSearchWalkIn", {
          inboundShipment: this.dataForm.inboundShipment,
          dockType: this.dataForm.dockType,
          apptDate: this.dataForm.apptDate,
        })
        .then((res) => {
          this.$store.commit('clearApiError');
          this.ibsError = null;
          this.loading = false;
          this.perIbs = this.dataForm.inboundShipment;
        })
        .catch((err) => {
          this.$store.commit('clearApiError');
          this.loading = false;
          this.perIbs = this.dataForm.inboundShipment;
          this.ibsError = err.messages.join(';');
        });
    },



     cancalAction(){
        this.showDialog = false;
        this.$store.commit('clearApiError');
     },


      async doSaveUser() {
        // if (this.ibsError != null )
        // {console.log( "Incorrect appointment! Check input!")}

        this.timeError = null;
        this.apptTimeInvalid = false;
        this.apptTimeFormatErr = null;
        this.$v.dataForm.$touch();
        console.log(`doSaveUser , invalid=${this.$v.dataForm.$invalid}`);
        // console.log(`Form data is ${JSON.stringify(this.dataForm)}`);
        if (this.$v.dataForm.$invalid) {
        //  this.$refs.top.$el.focus();
          return;
        }
        // if (this.ibsError && this.ibsError != "") {
        //   alert("Please fix inbound shipment error before process!!");
        //   return;
        // }

        const timeRef = moment('2021-04-01T' + this.dataForm.apptTime).format('HH:mm:ss');
        this.dataForm.apptDateLocal = dateFormat.getLocalDateOnly(this.dataForm.apptDate);
        // this.dataForm.apptDate = this.dataForm.apptDateLocal + 'T' + timeRef;
        this.dataForm.apptDate = this.dataForm.apptDateLocal;

        
        console.log(`Form data is ${JSON.stringify(this.dataForm)}`);

        const request = {
          // transloadingYard: this.dataForm.transloadingYard,
          transloadingYard: '1010001',
          receivingWindows: this.dataForm.receivingWindows,
          dockType: this.dataForm.dockType,
          apptDate: this.dataForm.apptDate,
          apptTime: this.dataForm.apptTime,
          ibs: this.dataForm.inboundShipment,
          username: this.dataForm.username,
          createdOn: this.dataForm.createdOn,
        };
      
        console.log(JSON.stringify(request));

        //await api.post("/api/w/fsi/WebGenerateInboundWalkIn", request).then((res) => {
        await newAPIPost("/api/w/fsi/WebGenerateInboundWalkIn", request).then((res) => {
          this.showDialog = false;
          this.$store.commit("clearApiError");
          this.action(this.dataForm.inboundShipment)
          }).catch((err) => {
             this.$store.commit('clearApiError');
             console.log("save error: " + err.messages.toString());
             console.log("err pos: " + err.messages.toString().indexOf('is not format in'));
             if (err.messages.toString().indexOf('is not format in') == 17) {
                this.apptTimeInvalid = true; 
                this.apptTimeFormatErr = err.messages.toString();
                console.log("set appt time invalid: " + this.apptTimeInvalid + "apptTimeFormatErr: " + this.apptTimeFormatErr);
             }   
          });

      },

    },
  };
</script>
